export default __webpack_public_path__ + "static/media/green_double_circle_check_mark.884fd14a.jpg";